import appSocket from "@/setup/io";

export default {
  leaveRoom(room) {
    return appSocket.emit("leave_room", room);
  },

  joinRoom(room) {
    return appSocket.emit("join_room", room);
  },

  sendMsg(msg) {
    return appSocket.emit("new_message", msg);
  }
};
